import React, { useState } from "react";
import IconText, { ICON_PLACEMENT } from "../IconText/IconText";
import { handleEnterKeypress } from "../../utils/keyEvents";
import {
  FaRegCheckCircle,
  FaRegCircle,
  FaArchive,
  FaReply
} from "react-icons/fa";
import "./Task.scss";
import AutoSizeTextArea from "../textArea/AutosizeTextArea";

import {
  archiveTask,
  unarchiveTask,
  updateTaskCompletionStatus,
  updateTaskName
} from "../../actions/taskActions";
import classNames from "classnames";
import { useAppSelector, useAppDispatch } from "../../hooks";
import type { Task as TaskModel } from "../../types/models";

export interface TaskProps {
  task: TaskModel;
  isCompletedList?: boolean;
}

export default function Task(props: TaskProps) {
  const dispatch = useAppDispatch();
  const { uid } = useAppSelector(state => state.userDetails);

  const [isCompletionIconHover, setIsCompletionIconHover] = useState(false);
  const [taskName, setTaskName] = useState(props.task.taskName);

  const onTaskNameChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTaskName(event.target.value);
  };

  const onTaskNameBlur = () => {
    dispatch(updateTaskName(props.task.id, taskName));
  };

  const onKeyPress = (event: React.KeyboardEvent) =>
    handleEnterKeypress(event, () =>
      dispatch(
        updateTaskCompletionStatus(props.task.id, !props.task.isCompleted)
      )
    );

  const onArchive = (event: React.SyntheticEvent) => dispatch(archiveTask(props.task.id, uid));
  const onUnarchive = (event: React.SyntheticEvent) => dispatch(unarchiveTask(props.task.id, uid));

  const TaskCompletionIcon =
    isCompletionIconHover || props.task.isCompleted
      ? FaRegCheckCircle
      : FaRegCircle;
  return (
    <IconText
      wrapperClassName="task-container"
      iconPlacement={ICON_PLACEMENT.AROUND}
    >
      {props.task.isArchived ? null : (
        <TaskCompletionIcon
          className="icon-wrapper"
          onClick={() =>
            dispatch(
              updateTaskCompletionStatus(props.task.id, !props.task.isCompleted)
            )
          }
          onFocus={() => setIsCompletionIconHover(true)}
          onBlur={() => setIsCompletionIconHover(false)}
          onMouseEnter={() => setIsCompletionIconHover(true)}
          onMouseLeave={() => setIsCompletionIconHover(false)}
          onKeyPress={onKeyPress}
          tabIndex={0}
          title={
            props.task.isCompleted ? "Reopen task" : "Click to complete task"
          }
        />
      )}
      <span className="task-name">
        <AutoSizeTextArea
          ariaLabel="task name"
          value={taskName}
          className={classNames("task-input", "body-layout-font")}
          onChange={onTaskNameChange}
          onBlur={onTaskNameBlur}
          additionalStyles={{
            textDecoration: props.task.isCompleted ? "line-through" : "none"
          }}
        />
      </span>
      {props.task.isArchived ? (
        <FaReply
          title="Unarchive task"
          className="icon-wrapper"
          onKeyPress={(event: React.KeyboardEvent) => handleEnterKeypress(event, onUnarchive)}
          onClick={onUnarchive}
          tabIndex={0}
        />
      ) : (
        <FaArchive
          title="Archive task"
          className="icon-wrapper"
          onKeyPress={(event: React.KeyboardEvent) => handleEnterKeypress(event, onArchive)}
          onClick={onArchive}
          tabIndex={0}
        />
      )}
    </IconText>
  );
}

const taskDefaultProps = {
  task: {}
};
